import React from 'react'
import { FormSing } from '../../ui/FormSing/FormSing'
import { SliderSing } from '../../ui/SliderSing/SliderSing'

export const ContainerSing = () => {
  return (
    <div className="ContainerSing">
        <FormSing/>
        <SliderSing/>
    </div>
  )
}
